import {Pipe, PipeTransform} from '@angular/core';
import {AgeGroupsData} from '../../types/nso-data-portal/census-data';

@Pipe({name: 'ageGroupName'})
export class AgeGroupNamePipe implements PipeTransform {
  transform(group: AgeGroupsData): string {
    if (!group) {
      return '';
    }
    return `${group.ageGroupName} (${group.startingAge} - ${group.endingAge})`;
  }
}
